var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M7.782 40.218a9.5 9.5 0 0 0 13.435 0l7-7a9.5 9.5 0 0 0 0-13.435 9.5 9.5 0 0 0-13.435 0l-7 7c-3.709 3.709-3.709 9.725 0 13.435zm3.536-9.9 7-7a4.5 4.5 0 0 1 6.364 6.364l-7 7a4.5 4.5 0 0 1-6.364-6.364z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.609 22.509S23 21 24.379 19.378l1.369-1.37a9.5 9.5 0 0 0-9.926.888c-.822 3.104.375 6.543.375 6.543l2.121-2.121c1.44-1.439 3.533-1.705 5.291-.809z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.827 22.193c-.082-.664-.178-2.024 1.022-3.345.07-.07.92-.94 1.143-1.163-2.642-1.109-5.689-.896-8.192.57-.849 2.578-.317 5.522 0 6.582l1.519-1.519a4.458 4.458 0 0 1 4.508-1.125z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M40.218 7.782a9.5 9.5 0 0 0-13.435 0l-7 7a9.5 9.5 0 0 0 0 13.435 9.5 9.5 0 0 0 13.435 0l7-7c3.709-3.709 3.709-9.725 0-13.435zm-3.536 9.9-7 7a4.5 4.5 0 0 1-6.364-6.364l7-7a4.5 4.5 0 0 1 6.364 6.364z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.386 25.476S25 27 23.621 28.622l-1.369 1.37a9.5 9.5 0 0 0 9.926-.888c.822-3.104-.375-6.543-.375-6.543l-2.121 2.121a4.476 4.476 0 0 1-5.296.794z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.188 25.806c.082.664.163 2.025-1.037 3.346l-1.143 1.143a9.03 9.03 0 0 0 8.196-.628c.849-2.578.314-5.445-.004-6.504l-1.519 1.519a4.508 4.508 0 0 1-4.493 1.124z",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M24.682 23.318a4.5 4.5 0 0 1 0 6.364l-7 7 3.536 3.536 7-7a9.5 9.5 0 0 0 0-13.435l-3.536 3.535z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLink);
export default __webpack_public_path__ + "static/media/status-link.f081cd05805e13a57c8110dd75ca4a40.svg";
export { ForwardRef as ReactComponent };